import styled from 'styled-components';

export const UL = styled.ul`
  font-size: 16px;
  line-height: 1.88;
  color: #3b4043;
  margin-top: 15px;
  margin-bottom: 15px;
`;
